/* @path: /src/pages/shelbula/workspaces/ConfirmationModals/ConfirmForcePullModal.jsx */
// @version: 1.0 (NEW FILE)
// @description: Confirmation modal for the destructive "Force Pull" operation.

import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { AlertTriangle, Loader } from 'lucide-react';

const ConfirmForcePullModal = ({ isOpen, onClose, onConfirm, workspaceName, isFetching }) => {
    return (
        <AnimatePresence>
            {isOpen && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60">
                    <motion.div
                        initial={{ opacity: 0, scale: 0.9 }}
                        animate={{ opacity: 1, scale: 1 }}
                        exit={{ opacity: 0, scale: 0.9 }}
                        className="bg-surface border border-border-color rounded-lg w-full max-w-md p-6 shadow-2xl"
                    >
                        <div className="flex items-start">
                            <div className="mr-4 flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-error/10">
                                <AlertTriangle className="h-6 w-6 text-error" />
                            </div>
                            <div>
                                <h3 className="text-lg font-semibold text-on-surface">Force Pull from Remote</h3>
                                <div className="mt-2 text-sm text-on-surface-dim space-y-3">
                                    <p>Are you sure you want to proceed?</p>
                                    <p>This is a <strong className="text-error font-bold">DESTRUCTIVE</strong> action. It will overwrite any changes in this workspace with the latest version from the remote branch.</p>
                                    <p className="font-semibold text-on-surface">All local (unsynced) changes will be permanently lost.</p>
                                </div>
                            </div>
                        </div>

                        <div className="mt-6 flex justify-end space-x-3">
                            <button
                                onClick={onClose}
                                disabled={isFetching}
                                className="px-4 py-2 text-sm font-medium rounded-md text-on-surface-dim hover:bg-surface-dark transition-colors disabled:opacity-50"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={onConfirm}
                                disabled={isFetching}
                                className="px-4 py-2 text-sm font-medium rounded-md text-white bg-error hover:bg-red-700 transition-colors flex items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                                {isFetching ? (
                                    <>
                                        <Loader className="animate-spin h-4 w-4 mr-2" />
                                        <span>Pulling...</span>
                                    </>
                                ) : (
                                    'Yes, Force Pull'
                                )}
                            </button>
                        </div>
                    </motion.div>
                </div>
            )}
        </AnimatePresence>
    );
};

export default ConfirmForcePullModal;